import type { MetricValue as MetricValueType, ScreenerColumn } from '@/types/screener';
import { formatMetric, metricTone, scoreTone } from './format';

interface MetricValueProps {
  value: MetricValueType;
  column: Pick<ScreenerColumn, 'key' | 'unit' | 'change'>;
  className?: string;
}

export default function MetricValue({ value, column, className = '' }: MetricValueProps) {
  if (value === null || value === undefined || value === '') {
    return (
      <span className={`text-zinc-400 dark:text-zinc-600 ${className}`} title="Not reported for this stock">
        —
      </span>
    );
  }

  if (column.unit === 'score' && !column.change && typeof value === 'number') {
    const tone = scoreTone(value);
    return (
      <span className={`inline-flex items-center gap-2 tabular-nums ${className}`}>
        <span className="h-1.5 w-12 overflow-hidden rounded-full bg-zinc-200 dark:bg-zinc-700">
          <span className={`block h-full rounded-full ${tone.bar}`} style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }} />
        </span>
        <span className={`font-semibold ${tone.text}`}>{formatMetric(value, column)}</span>
      </span>
    );
  }

  return (
    <span className={`tabular-nums ${metricTone(value, column)} ${className}`}>
      {formatMetric(value, column)}
    </span>
  );
}

export function ExchangeBadge({ exchange }: { exchange: string }) {
  const isNse = exchange.toUpperCase() === 'NSE';
  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-px text-[10px] font-semibold tracking-wide ${
        isNse
          ? 'bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300'
          : 'bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300'
      }`}
    >
      {exchange.toUpperCase()}
    </span>
  );
}
